import styled from 'styled-components';
import { STANDARD_HEADER_TOP_MARGIN } from '../utils/spacing';
import H2 from 'UIComponents/elements/headings/H2';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH2 = styled(H2).withConfig({
  displayName: "MdxH2__StyledH2",
  componentId: "sc-1kxc2hv-0"
})(["margin-top:", ";"], STANDARD_HEADER_TOP_MARGIN);
function MdxH2(props) {
  return /*#__PURE__*/_jsx(MdxHeader, Object.assign({
    Component: StyledH2
  }, props));
}
export default MdxH2;